import { ZuriEn } from '@zuri/en'
import { ClientScripts } from './ClientScripts'
import './style.css'

let hasSetFeeCover = false

let nudgePosition: 'top' | 'bottom' = 'top'

const setFeeCover = () => {
  const feeCoverCheckbox = document.querySelector<HTMLInputElement>(
    '#en__field_transaction_feeCover',
  )
  if (feeCoverCheckbox) {
    feeCoverCheckbox.checked = true
    feeCoverCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
    feeCoverCheckbox.dispatchEvent(new Event('click', { bubbles: true }))
    hasSetFeeCover = true
  }
}

const enConfig = {
  globalConfig: {
    requiredAsterisk: false,
  },
  hero: {
    enabled: true,
  },
  validation: {
    embeddedUpsell: true,
    dynamicNextLabels: true,
    dynamicBackLabel: true,
    //onSetupComplete: (v) => console.log('ready', v.steps.length),
    onStepChange: ({
      totalSteps,
      currentStep,
      isLastStep,
    }: {
      totalSteps: number
      currentStep: number
      isLastStep: boolean
    }) => {
      // Auto-check the fee cover checkbox when the user reaches the last step, if it hasn't already been checked by an earlier script.
      if (isLastStep && !hasSetFeeCover && totalSteps > 1) {
        setFeeCover()
      }
    },
  },
  recurringNudge: {
    defaultText: 'A recurring gift does even more!',
    position: nudgePosition,
    arrowPosition: 'left',
    customFieldSelector: '[name="supporter.NOT_TAGGED_38"]',
    autoHide: false,
  },
  eCard: {
    picker: {
      deliveryOptionsSelector: '.en__field--NOT_TAGGED_7',
    },
    sender: {
      enabled: true,
    },
  },
  donationAmount: {
    suffix: {
      MONTHLY: '/mo',
      ANNUAL: '/yr',
    },
    otherAmountPlaceholder: '$ Other Amount',
    otherAmountStyle: 'classic',
  },
  giftSummary: {
    frequencyText: {
      ONE_TIME: '(One Time)',
      MONTHLY: '(Monthly)',
      ANNUAL: '(Annually)',
    },
  },
  countryRegion: {
    regionLabels: { US: 'State', CA: 'Province', GB: 'County' },
    postcodeLabels: { US: 'Zip Code', CA: 'Postal Code', GB: 'Postcode' },
    defaultRegionLabel: 'Region',
  },
}

new ZuriEn(enConfig)
new ClientScripts()
